import { defineStore } from 'pinia';
import { Store } from '@/setup/globals';
import { setInitialData } from '@/stores/initial-data';
import { BreadcrumbItem } from '@/types/breadcrumb';

export type StoreState = {
  items: BreadcrumbItem[];
};

const storeName = Store.Breadcrumb;

export default defineStore(storeName, {
  state: () => {
    const state: StoreState = {
      items: [],
    };

    const initialData: StoreState = window.initialData?.[storeName] || {};

    setInitialData(state, initialData);

    return state;
  },
});
